import '@babel/polyfill'
import Vue from 'vue'

//  Librerie interne
import App from '@/App.vue'
import api from '@/api'
import router from '@/router'
import store from '@/store'
import schemas from '@/schemas'
import utils from '@/utils'

//  Librerie esterne
import '@/plugins/vuetify'
import '@mdi/font/css/materialdesignicons.css'
import i18n from '@/plugins/i18n'
import '@/plugins/google-maps'
import * as VueGoogleCharts from 'vue-google-charts'
import bowser from 'bowser'

//  Scss
import '@/theme.scss'

//  Configurazione Vue
Vue.use(VueGoogleCharts)
// Vue.config.performance = true
Vue.config.productionTip = false

//  Registrazzione variabili globali
Vue.prototype.$api = api
Vue.prototype.$schemas = schemas
Vue.prototype.$utils = utils
Vue.prototype.$bowser = bowser.getParser(window.navigator.userAgent)

//  Inizializzazione Vue
new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
}).$mount('#app')
